import React from 'react';

interface MessageDisplayProps {
  message?: { type: 'success' | 'error'; text: string } | null;
}

export function MessageDisplay({ message }: MessageDisplayProps) {
  if (!message) return null;

  const isSuccess = message.type === 'success';
  
  return (
    <div 
      className={`mb-6 p-4 rounded-lg soft-glass border ${
        isSuccess 
          ? 'border-neon-green text-text-dark' 
          : 'border-red-400 text-text-dark'
      }`}
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center space-x-2">
        <span className="label-tag">
          {isSuccess ? 'SUCCESS' : 'ERROR'}
        </span>
        <span className="font-medium">{message.text}</span>
      </div>
    </div>
  );
} 